import { jsxs as t, jsx as r } from "@emotion/react/jsx-runtime";
import { useMemo as I } from "react";
import { HorizontalCardContainer as x, LeftContainer as C, StyledImage as _, TextContainer as g } from "./HorizontalCard.styled.js";
import { Checkbox as H } from "../../Checkbox/index.js";
import { Radio as b } from "../../Radio/index.js";
import { Text as s } from "../../Text/index.js";
const u = 40, w = 40, R = ({
  disabled: m = !1,
  checked: a = !1,
  onChange: f,
  value: h,
  title: e,
  titleVariant: p,
  subtitle: i,
  imageSrc: n,
  inputType: o,
  inputPosition: d
}) => {
  const c = {
    dataTrackId: "horizontal__card__input",
    "aria-label": e,
    "aria-disabled": m,
    "aria-checked": a,
    type: o,
    checked: a,
    onChange: f,
    value: h
  }, l = I(() => o === "radio" ? b : H, [o]);
  return /* @__PURE__ */ t(x, { direction: "row", justifyContent: "space-between", children: [
    /* @__PURE__ */ t(C, { direction: "row", alignItems: "center", children: [
      d === "left" && /* @__PURE__ */ r(l, { ...c }),
      n !== void 0 && /* @__PURE__ */ r(_, { width: u, height: w, src: n, alt: "" }),
      /* @__PURE__ */ t(g, { gap: "0px", children: [
        /* @__PURE__ */ r(s, { id: "", variant: p, color: "default", children: e }),
        i && /* @__PURE__ */ r(s, { variant: "bodyMRegular", children: i })
      ] })
    ] }),
    d === "right" && /* @__PURE__ */ r(l, { ...c })
  ] });
};
export {
  R as HorizontalCard
};
